import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import Select from 'react-select';
import InputDatePicker from 'components/pages/customer-service/action-plans/create-action-plan/InputDatePicker';
import './WpoDashboard.css';
import { getSuppliers } from 'services/stock-location/wpoDashboardService';
import PropTypes from 'prop-types';

function WpoDashboardFilter({
  filter,
  handleChange,
  handleSubmit,
  statusOptions
}) {
  const [supplierOptions, setSupplierOptions] = useState([]);
  useEffect(() => {
    getSuppliers().then(res => {
      const options =
        res.data?.map(x => ({
          label: `${x.supplierName?.trim()} (${x.supplierId})`,
          value: x.supplierId
        })) ?? [];

      setSupplierOptions(options);
    });
  }, []);

  const handleDateFilterChange = (field, value) => {
    handleChange(field, value);
  };

  return (
    <Card className="mb-3 wpo-panel">
      <Card.Body>
        <Row className="g-3">
          <Col lg={4}>
            <Card className="h-100 wpo-search-card">
              <Card.Body>
                <h2 className="wpo-search-title">Search By</h2>

                <Form.Group className="mb-3">
                  <Form.Label className="wpo-field-label">Supplier</Form.Label>

                  <Select
                    isClearable
                    options={supplierOptions}
                    value={
                      supplierOptions.find(
                        x => x.value === filter.supplierId
                      ) || null
                    }
                    onChange={option =>
                      handleChange('supplierId', option?.value)
                    }
                    placeholder="Select supplier..."
                    classNamePrefix="react-select"
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: base => ({
                        ...base,
                        zIndex: 9999
                      })
                    }}
                  />
                </Form.Group>

                <Form.Group>
                  <Form.Label className="wpo-field-label">WPO</Form.Label>

                  <Form.Control
                    placeholder="e.g. WPO123456, WPO123457"
                    value={filter.keyword || ''}
                    onChange={e => handleChange('keyword', e.target.value)}
                  />
                </Form.Group>
              </Card.Body>
            </Card>
          </Col>

          <Col lg={8}>
            <Card className="h-100 wpo-search-card">
              <Card.Body>
                <h2 className="wpo-search-title">Filter By</h2>

                <Row className="g-3">
                  <Col md={12}>
                    <Form.Label className="wpo-field-label">
                      Order Status
                    </Form.Label>

                    <Select
                      isMulti
                      options={statusOptions}
                      value={filter.statuses}
                      onChange={options =>
                        handleChange('statuses', options || [])
                      }
                      closeMenuOnSelect={false}
                      placeholder="Select status..."
                      classNamePrefix="react-select"
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: base => ({
                          ...base,
                          zIndex: 9999
                        })
                      }}
                    />
                  </Col>

                  <Col md={6}>
                    <Form.Label className="wpo-field-label">
                      Ordered From
                    </Form.Label>

                    <InputDatePicker
                      column="orderedFrom"
                      selected={filter.orderedFrom}
                      handleChange={handleDateFilterChange}
                      useUTC={true}
                    />
                  </Col>

                  <Col md={6}>
                    <Form.Label className="wpo-field-label">
                      Ordered To
                    </Form.Label>

                    <InputDatePicker
                      column="orderedTo"
                      selected={filter.orderedTo}
                      handleChange={handleDateFilterChange}
                      useUTC={true}
                    />
                  </Col>

                  <Col md={6}>
                    <Form.Label className="wpo-field-label">
                      Due From
                    </Form.Label>

                    <InputDatePicker
                      column="dueFrom"
                      selected={filter.dueFrom}
                      handleChange={handleDateFilterChange}
                      useUTC={true}
                    />
                  </Col>

                  <Col md={6}>
                    <Form.Label className="wpo-field-label">Due To</Form.Label>

                    <InputDatePicker
                      column="dueTo"
                      selected={filter.dueTo}
                      handleChange={handleDateFilterChange}
                      useUTC={true}
                    />
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <div className="pt-3">
          <Button
            type="button"
            className="wpo-search-btn"
            onClick={handleSubmit}
          >
            Search
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
}
WpoDashboardFilter.propTypes = {
  filter: PropTypes.object,
  handleChange: PropTypes.func,
  handleSubmit: PropTypes.func,
  statusOptions: PropTypes.array
};
export default WpoDashboardFilter;
